// src/components/plantaDetailForm.js
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid,
    Switch,
    FormControlLabel,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Checkbox,
    OutlinedInput,
} from '@mui/material';
import api from './api'; // Asegúrate de tener api.js configurado


function PlantaDetailForm({ open, onClose, planta, onSave }) {
    const [fabricantesDisponibles, setFabricantesDisponibles] = useState([]);
    const [tiposOperacionDisponibles, setTiposOperacionDisponibles] = useState([]);
    const [supervisores, setSupervisores] = useState([]);
    const [coordinadores, setCoordinadores] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [clientesDisponibles, setClientesDisponibles] = useState([]);

    const [formData, setFormData] = useState({
        id: planta?.id || null,
        name: planta?.name || '',
        determinante: planta?.determinante || '',
        fabricante: planta?.fabricante || '',
        cliente: planta?.cliente || '',
        tipoOperacion: planta?.tipo_de_operacion_id || '',
        zona: planta?.zona || '',
        formato: planta?.formato || '',
        elementoPep: planta?.elemento_pep || '',
        tipoContrato: planta?.tipo_de_contrato || '',//Creo que este va en cliente
        supervisor: planta?.supervisor || '',
        contactoSupervisor: planta?.contacto_supervisor || '',
        coordinador: planta?.coordinador || '',
        contactoCoordinador: planta?.contacto_coordinador || '',
        assignedOperadores: planta?.usuarios?.map(u => u.username) || [],
        descanso: planta?.descanso || [],
        estatus: planta?.estatus || false,
        creationDate: planta?.creationDate || '',
        updateDate: planta?.updateDate || '',
    });

    const [errors, setErrors] = useState({}); //estado para los errores

    //Nuevo estado para determinar si estamos en modo de creación 
    const isCreating = formData.id === null;

    const [checkedAssigned, setCheckedAssigned] = useState([]);

    const dias_descanso = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
    const tipos_contrato = ['Arrendamiento', "Iguala de Operación", "Garantía Extendida", "Arrendamiento Banorte",
        "Arrendamiento a 5 años", "Iguala integral"]
    const lista_formatos = ['CO', 'BA', 'MB', 'SC', 'SM',
        'ADO', 'CEDIS','CT','FG','HD','LV','RT','TL']

    //campos obligatorios
    const requiredFields = [
        'name',
        'determinante',
        'fabricante',
        'cliente',
        'tipoOperacion',
        'zona',
        'supervisor',
        'coordinador',
        'estatus',
        'descanso',
        'tipoContrato'
    ];


    //useEffect para cargar datos iniciales
    useEffect(() => {
        api.get('/fabricante/?skip=0&limit=1000')
            .then((res) => {
                const activos = res.data.filter(f => f.is_active);
                setFabricantesDisponibles(activos);
            })
            .catch((err) => {
                console.error('Error al cargar fabricantes', err);
                setFabricantesDisponibles([]);
            });
        api.get('/zonas/?skip=0&limit=1000')
            .then((res) => {
                setZonas(res.data);
            })
            .catch((err) => {
                console.error('Error al cargar zonas:', err);
                setZonas([]);
            });
        api.get('/clientes/?skip=0&limit=1000')
            .then((res) => {
                setClientesDisponibles(res.data);
            })
            .catch((err) => {
                console.error('Error al cargar clientes:', err);
                setClientesDisponibles([]);
            });
        api.get('/tipo_operacion/?skip=0&limit=1000')
            .then((res) => {
                setTiposOperacionDisponibles(res.data);
            })
            .catch((err) => {
                console.error('Error al cargar tipos de operación', err);
                setTiposOperacionDisponibles([]);
            });
        const fetchUsuarios = async () => {
            try {
                const response = await api.get('/users/?skip=0&limit=1000');
                const data = response.data;
                setSupervisores(data.filter(u => u.role === 'supervisor' && u.is_active));
                setCoordinadores(data.filter(u => u.role === 'coordinador' && u.is_active));
            } catch (err) {
                console.error('Error al obtener usuarios:', err);
            }
        };
        fetchUsuarios();
    }, []);


    // useEffect para inicializar formData y limpiar errores cuando 'planta' cambia o se abre el diálogo
    useEffect(() => {
        if (open) { // Solo si el diálogo está abierto o se acaba de abrir
            if (planta) {
                //console.log('🟢 Datos crudos de planta:', planta);
                const supervisorCompleto = supervisores.find(s => s.id === planta.supervisor_id);
                const coordinadorCompleto = coordinadores.find(c => c.id === planta.coordinador_id);
                setFormData({
                    id: planta?.id || null,
                    name: planta?.nombre || '',
                    determinante: planta?.determinante || '',
                    fabricante: planta?.fabricante_id || '', // Asegúrate de que esto es el ID
                    cliente: planta?.cliente_id || '',       // Asegúrate de que esto es el ID
                    tipoOperacion: planta?.tipo_de_operacion_id || '', // Asegúrate de que esto es el ID
                    zona: planta?.zona_id || '',             // Asegúrate de que esto es el ID
                    formato: planta?.formato || '',
                    elementoPep: planta?.elemento_pep || '',
                    tipoContrato: planta?.tipo_de_contrato || '',
                    supervisor: planta?.supervisor_id || '',
                    contactoSupervisor: supervisorCompleto?.contacto || '',
                    coordinador: planta?.coordinador_id || '',
                    contactoCoordinador: coordinadorCompleto?.contacto || '',
                    assignedOperadores: planta?.usuarios?.map(u => u.username) || [],
                    descanso: planta?.descanso || [],
                    estatus: planta?.is_active || false,
                    creationDate: planta?.created_at || '',
                    updateDate: planta?.updated_at || '',
                });
                setCheckedAssigned([]);
            } else {
                setFormData({
                    id: null,
                    name: '',
                    determinante: '',
                    fabricante: '',
                    cliente: '',
                    tipoOperacion: '',
                    zona: '',
                    formato: '',
                    elementoPep: '',
                    tipoContrato: '',
                    supervisor: '',
                    contactoSupervisor: '',
                    coordinador: '',
                    contactoCoordinador: '',
                    assignedOperadores: [],
                    descanso: [],
                    estatus: false,
                    creationDate: '',
                    updateDate: '',
                });
                setCheckedAssigned([]);
            }
            setErrors({}); // ¡IMPORTANTE! Limpiar errores cada vez que el diálogo se abre o la planta cambia
        }
    }, [open, planta, supervisores, coordinadores]); // Añade 'open' como dependencia aquí

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;

        // Limpiar el error si el usuario empieza a escribir/seleccionar en el campo
        if (errors[name]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: false,
            }));
        }

        if (name === 'supervisor') {
            const selected = supervisores.find(s => s.id === value);
            setFormData((prev) => ({
                ...prev,
                supervisor: value,
                contactoSupervisor: selected?.contacto || ''
            }));
        } else if (name === 'coordinador') {
            const selected = coordinadores.find(c => c.id === value);
            setFormData((prev) => ({
                ...prev,
                coordinador: value,
                contactoCoordinador: selected?.contacto || ''
            }));
        } else if (name === 'descanso') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: typeof value === 'string' ? value.split(',') : value,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    const handleSave = async () => {
        const newErrors = {};
        let isValid = true;

        requiredFields.forEach(field => {
            const value = formData[field];
            // Para TextFields (cadenas): verifica si está vacío o solo con espacios
            if (typeof value === 'string' && value.trim() === '') {
                newErrors[field] = true;
                isValid = false;
            }
            // Para Selects (pueden tener valores numéricos o strings): verifica si es null, undefined, 0 o cadena vacía
            else if (value === null || value === undefined || value === '' || value === 0) {
                newErrors[field] = true;
                isValid = false;
            }

            else if (Array.isArray(value) && value.length === 0) {
                newErrors[field] = true;
                isValid = false;
            }
        });

        setErrors(newErrors); // Actualiza el estado de errores para re-renderizar

        if (!isValid) {
            console.error('Campos obligatorios vacíos:', newErrors);
            return; // ¡IMPORTANTE! Detiene la ejecución aquí si hay errores de validación
        }

        // Si la validación pasa, procede con el guardado
        try {
            const payload = {
                nombre: formData.name,
                determinante: formData.determinante,
                fabricante_id: formData.fabricante,
                cliente_id: formData.cliente,
                tipo_de_operacion_id: formData.tipoOperacion,
                zona_id: formData.zona,
                formato: formData.formato,
                elemento_pep: formData.elementoPep,
                tipo_de_contrato: formData.tipoContrato,
                supervisor_id: formData.supervisor,
                coordinador_id: formData.coordinador,
                descanso: formData.descanso,
                is_active: formData.estatus,
                descripcion_planta: formData.name,
            };

            if (formData.id) {
                await api.put(`/plantas/${formData.id}`, payload);
            } else {
                payload.password = formData.password;
                await api.post('/plantas/', payload);
            }

            //--REVISAR POR QUE CHAY DISCREPANCIA EN LOS OBJETOS  QUE SE PASA PARA LA EDICION
            //VS LOS QUE ESPERA PLANTADETAIL
            //Crear objeto enriquecido para pasar al dashboard 
            const savedPlantaForDashboard = {
                id: formData.id, // Usa el ID que la API te devuelve para plantas nuevas
                nombre: formData.name,
                determinante: formData.determinante,
                is_active: formData.is_active, // O is_active si es el nombre de la API
                // Buscar el objeto completo de fabricante y zona por su ID
                fabricante: fabricantesDisponibles.find(fab => fab.id === formData.fabricante) || { nombre: 'Desconocido' },
                zona: zonas.find(z => z.id === formData.zona) || { nombre: 'Desconocido' },
                cliente: clientesDisponibles.find(zz => zz.id === formData.cliente) || { nombre: 'Desconocido' },
                // ... incluir cualquier otra propiedad que tu tabla de dashboard necesite
                // y que no venga directamente enriquecida en apiResponseData.
            };

            // Estas líneas solo se ejecutan si la API responde exitosamente
            onSave(savedPlantaForDashboard);
            onClose();
        } catch (error) {
            console.error('Error al guardar planta:', error.response?.data || error.message || error);
            alert(`Ocurrió un error al guardar la planta: ${error.response?.data?.detail || error.message || 'Error desconocido'}`);
        }
    };



    const handleCancel = () => {
        onClose();
    };

    const handleToggleAssigned = (value) => () => {
        const currentIndex = checkedAssigned.indexOf(value);
        const newCheckedAssigned = [...checkedAssigned];

        if (currentIndex === -1) {
            newCheckedAssigned.push(value);
        } else {
            newCheckedAssigned.splice(currentIndex, 1);
        }
        setCheckedAssigned(newCheckedAssigned);
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Detalle de Planta</Typography>
                    <Typography variant="body2" color="text.secondary">Planta &gt; Detalle</Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Nombre"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            required
                            error={!!errors.name}
                            helperText={errors.name ? 'Este campo es obligatorio' : ''}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Determinante"
                            name="determinante"
                            value={formData.determinante}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            required
                            error={!!errors.determinante}
                            helperText={errors.determinante ? 'Este campo es obligatorio' : ''}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.fabricante}>
                            <InputLabel id="fabricante-label">Fabricante</InputLabel>
                            <Select
                                labelId="fabricante-label"
                                label="Fabricante"
                                name="fabricante"
                                value={formData.fabricante}
                                onChange={handleChange}
                            >
                                {fabricantesDisponibles.map((fab) => (
                                    <MenuItem key={fab.id} value={fab.id}>
                                        {fab.nombre} – {fab.tecnologia}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.fabricante && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.cliente}>
                            <InputLabel id="cliente-label">Cliente</InputLabel>
                            <Select
                                labelId="cliente-label"
                                label="Cliente"
                                name="cliente"
                                value={formData.cliente}
                                onChange={handleChange}
                            >
                                {clientesDisponibles.map((cliente) => (
                                    <MenuItem key={cliente.id} value={cliente.id}>
                                        {cliente.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.cliente && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>


                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.tipoOperacion}>
                            <InputLabel id="tipo-operacion-label">Tipo de Operación</InputLabel>
                            <Select
                                labelId="tipo-operacion-label"
                                label="Tipo de Operación"
                                name="tipoOperacion"
                                value={formData.tipoOperacion}
                                onChange={handleChange}
                            >
                                {tiposOperacionDisponibles.map((tipo) => (
                                    <MenuItem key={tipo.id} value={tipo.id}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.tipoOperacion && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.zona}>
                            <InputLabel>Zona</InputLabel>
                            <Select
                                label="Zona"
                                name="zona"
                                value={formData.zona}
                                onChange={handleChange}
                            >
                                {zonas.map((zona) => (
                                    <MenuItem key={zona.id} value={zona.id}>
                                        {zona.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.zona && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="formato-label">Formato</InputLabel>
                            <Select
                                labelId="formato-label"
                                label="Formato"
                                name="formato"
                                value={formData.formato}
                                onChange={handleChange}
                            >
                                {lista_formatos.map((formato) => (
                                    <MenuItem key={formato} value={formato}>
                                        {formato}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            fullWidth
                            label="Elemento pep"
                            name="elementoPep"
                            value={formData.elementoPep}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.supervisor}>
                            <InputLabel id="supervisor-label">Supervisor</InputLabel>
                            <Select
                                labelId="supervisor-label"
                                label="Supervisor"
                                name="supervisor"
                                value={formData.supervisor}
                                onChange={handleChange}
                            >
                                {supervisores.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {`${s.nombre} ${s.a_paterno} ${s.a_materno}`}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.supervisor && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>

                    {formData.supervisor && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Contacto Supervisor"
                                name="contactoSupervisor"
                                value={formData.contactoSupervisor}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                disabled
                            />
                        </Grid>
                    )}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.coordinador}>
                            <InputLabel id="coordinador-label">Coordinador</InputLabel>
                            <Select
                                labelId="coordinador-label"
                                label="Coordinador"
                                name="coordinador"
                                value={formData.coordinador}
                                onChange={handleChange}
                            >
                                {coordinadores.map((c) => (
                                    <MenuItem key={c.id} value={c.id}>
                                        {`${c.nombre} ${c.a_paterno} ${c.a_materno}`}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.coordinador && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>

                    {formData.coordinador && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Contacto Coordinador"
                                name="contactoCoordinador"
                                value={formData.contactoCoordinador}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                disabled
                            />
                        </Grid>
                    )}

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.estatus}
                                    onChange={handleChange}
                                    name="estatus"
                                    color="primary"
                                />
                            }
                            label="Estatus"
                            labelPlacement="start" // Posiciona el label al principio
                            sx={{ m: 0, justifyContent: 'space-between', width: '100%' }} // Alinea Switch y Label
                            required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.descanso}>
                            <InputLabel id="descanso-label">Descanso</InputLabel>
                            <Select
                                labelId="descanso-label" // Añade un labelId para accesibilidad
                                label="Descanso"
                                name="descanso" // Asegúrate de que el nombre coincide con el estado
                                value={formData.descanso}
                                onChange={handleChange}
                                required
                                multiple // ¡Esta es la prop clave para selección múltiple!
                                input={<OutlinedInput label="Descanso" />} // Para mostrar los chips de selección
                                renderValue={(selected) => selected.join(', ')} // Cómo se ven los valores seleccionados
                            >
                                {dias_descanso.map((descanso) => (
                                    <MenuItem key={descanso} value={descanso}>
                                        <Checkbox checked={formData.descanso.indexOf(descanso) > -1} />
                                        <ListItemText primary={descanso} />
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.descanso && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small" required
                            error={!!errors.tipoContrato}>
                            <InputLabel>Tipo de contrato</InputLabel>
                            <Select
                                label="tipoContrato"
                                name="tipoContrato"
                                value={formData.tipoContrato}
                                onChange={handleChange}
                            >
                                {tipos_contrato.map((tipoContrato) => (
                                    <MenuItem key={tipoContrato} value={tipoContrato}>
                                        {tipoContrato}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.tipoContrato && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                    Este campo es obligatorio
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>


                    {/* Sección para mostrar operadores*/}
                    {!isCreating && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography variant="subtitle1" gutterBottom>Operadores</Typography>
                            <Grid container spacing={2} alignItems="center">

                                <Grid size={{ xs: 12, sm: 5 }}>
                                    <List dense sx={{ width: '100%', height: 200, overflow: 'auto', border: '1px solid #ccc' }}>
                                        

                                        {formData.assignedOperadores.map((plant, index) => (
                                            
                                            <ListItem
                                                key={plant}
                                                onClick={handleToggleAssigned(index)}
                                                button
                                            >

                                                <ListItemText primary={plant} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    {!isCreating && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Fecha de Creación"
                                name="creationDate"
                                value={formData.creationDate}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                disabled
                            // type="date" // Si quieres un selector de fecha real
                            // InputLabelProps={{ shrink: true }} // Para que el label no se superponga
                            />
                        </Grid>
                    )}

                    {!isCreating && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Fecha actualización"
                                name="updateDate"
                                value={formData.updateDate}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                disabled
                            // type="date" // Si quieres un selector de fecha real
                            // InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'flex-end', gap: 1 }}>
                <Button variant="outlined" onClick={handleCancel}>
                    Cancelar
                </Button>
                <Button variant="contained" onClick={handleSave}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PlantaDetailForm;